// extracted by mini-css-extract-plugin
export default {"is-menu-flipped":"styles_is-menu-flipped__s3NuN"};